/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  editClipResponse: null,
  editClip: null

};

const reducer = (state = initialState, action = {}) => {

  switch (action.type) {
    case actions.EditClipAction.REQUEST_EDITCLIP:
      return {
        ...state
      };

    
    case actions.EditClipAction.EDITCLIP_RECEIVED:
      return {
        ...state,
        editClipResponse : action.data.response,
        editClip: action.data.statusCode
      };

      case actions.EditClipAction.CLEAR_EDITCLIP:
        return {
          ...state,
          editClip: 0,
        };

    default:
      return state;
  }
};

export default reducer;
